import React from 'react';
import './CartUpsell.scss';
import { formatMoney } from '@shopify/theme-currency';

/**
 * Render upsell product item in cart
 * @param {Object} product
 * @param {Function} addAction
 * @returns {JSX.Element}
 * @constructor
 */
const CartUpsell = ({ product, addAction, format }) => (
  <div className="c-cart-upsell background-color-orange">
    <div className="c-cart-upsell__leading">
      <div className="c-cart-upsell__img-wrapper">
        <img
          src={product.featured_img.url}
          alt={product.featured_img.alt}
          className="c-cart-upsell__img"
        />
      </div>
      <div className="c-cart-upsell__content">
        <div className="c-cart-upsell__title body-1 color-black">{product.title}</div>
        <span className="c-cart-upsell__price eyebrow-2 color-black">
          {formatMoney(product.price, format)}
        </span>
      </div>
    </div>
    <button
      className="c-cart-upsell__add-btn eyebrow-1 color-black"
      onClick={() => addAction(product)}
    >
      + Add
    </button>
  </div>
);

export default CartUpsell;
